import { render, staticRenderFns } from "./specialservcarousel.vue?vue&type=template&id=e3412016&"
import script from "./specialservcarousel.vue?vue&type=script&lang=js&"
export * from "./specialservcarousel.vue?vue&type=script&lang=js&"
import style0 from "./specialservcarousel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports